const state = {
    id: null,
    client: {},
    name: '',
    daily_hours: 0,
    weekly_hours: 0,
    shift_allowance_percentage: 100,
    overtime_percentage: 100,
    overtime_message: '',
    days: {},
    allow_comments: false,
    allow_reimbursement: false,
    is_net: false
}

export default state
